import { styled } from '@cp/ds/src/theme';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { ContainerCssTokens } from '@youhelp-ru/ui';
import { ComponentType } from 'react';
import { DESKTOP_LAYOUT_WIDTH, Tokens, name } from './const';

export const Root = styled(Box, { name })(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  containerType: 'inline-size',
  width: '100%',
  boxSizing: 'border-box',
  backgroundColor: Tokens.listBackground(theme.palette['gray background']),
  [Tokens.gap]: '12px',
  [Tokens.colorPaper]: theme.palette.background.default,
  [Tokens.colorBorder]: theme.palette['gray light'],
  [ContainerCssTokens.offset]: Tokens.gap(),
  [ContainerCssTokens.width]: Tokens.maxWidth('660px'),
  [Tokens.listGap]: theme.spacing(1.5),
  [`@container (min-width: ${DESKTOP_LAYOUT_WIDTH})`]: {
    [Tokens.listGap]: theme.spacing(2.5),
    [Tokens.headerGap]: theme.spacing(1),
  },
})) as unknown as ComponentType<BoxProps>;
Root.displayName = `Entities/${name}`;
